import { Pipe, PipeTransform } from '@angular/core'

import { Marked } from 'marked'
import markedFootnote from 'marked-footnote'
import { mangle } from 'marked-mangle'

// this token makes sure that markdown tables render properly.
const templateLiteralMultilineToken = `
`

function sanitizeString(value: string): string {
  if (!value) {
    return value
  }
  const normalizedNewlineValue = value.toString().replace(/\\r|\\n|\r|\n/g, '<br/>')
  if (!normalizedNewlineValue) {
    return normalizedNewlineValue
  }
  const templateLiteralValue = normalizedNewlineValue
    .toString()
    .replace(/(?:<br\/>)/g, templateLiteralMultilineToken)

  return templateLiteralValue
}

@Pipe({
  name: 'flxAiMarkdown',
  standalone: true,
})
export class FlxAiMarkdownPipe implements PipeTransform {
  async transform(value: string): Promise<string> {
    if (value === null || value === undefined) {
      return ''
    }

    const aiMarked = new Marked(mangle()).use(markedFootnote({ refMarkers: true }))

    const renderer = new aiMarked.Renderer({})
    // make anchors open in new tab
    renderer.link = (...args) => {
      const link = aiMarked.Renderer.prototype.link.apply(this, args)
      return link.replace('<a', "<a target='_blank'")
    }

    // passed vale needs to be a string
    return aiMarked.parse(`${sanitizeString(value)}`, { renderer })
  }
}

@Pipe({
  name: 'highlightBracketed',
  standalone: true,
})
export class HighlightBracketedPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value
    }

    // Use regex to find and wrap bracketed numbers
    return value.replace(
      /\[(\d+)\]/g, // Regular expression to match numbers within brackets
      '<span class="text-yellow-500 inline text-xs font-semibold">[$1]</span>'
    )
  }
}
